import React from 'react';

import { BrandFolder } from '../BrandFolder';

const Underwriting = () => (
  <BrandFolder title="Underwriting Resources" typeOfContainer="Underwriting" />
);

export default Underwriting;
